<mat-dialog-actions class="justify-content-between">
    <h3>{{ 'BUTTON.BTN_FOLLOW_UP' | translate }}</h3>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>

<mat-dialog-content>
    <app-follow-up-slot-picker [doctorId]="data.doctorId"></app-follow-up-slot-picker>
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row m-t-4">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button class="m-r-5" (click)="onCloseDialog()">
                {{ 'BUTTON.BTN_CLOSE' | translate }}
            </button>
            <button mat-flat-button color="primary" (click)="onSaveFollowUp()"
                [disabled]="followUpSlotPicker?.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}
            </button>
        </div>
    </div>
</mat-dialog-actions>
